import {
  Component,
  effect,
  inject,
  Input,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import Chart from 'chart.js/auto';
import { AppStateService } from 'src/app/core/services/app-state.service';

@Component({
  selector: 'app-base-doughnut-chart',
  templateUrl: './base-doughnut-chart.component.html',
  styleUrls: ['./base-doughnut-chart.component.scss'],
  standalone: false,
})
export class BaseDoughnutChartComponent implements OnInit {
  public chart: any;
  loading: boolean = true;
  isEmpty: boolean = false;

  @Input() chartId: string = '';
  @Input() title: string;
  @Input() labels: string[] = [];
  @Input() data: number[];
  @Input() colors: string[];
  @Input() fontColor: string = '#999';
  @Input() type?: 'doughnut' | 'pie' = 'doughnut';
  @Input() legendPosition?: 'top' | 'bottom' | 'left' | 'right' = 'top';

  appStateService = inject(AppStateService);

  constructor() {
    effect(() => {
      if (this.appStateService.currentThemeMode() == 'light')
        Chart.defaults.color = '#888888ff';
      else Chart.defaults.color = '#ffffff';
      this.createChart();
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['labels'] || changes['data'] || changes['colors']) {
      if (this.labels?.length && this.data?.length && this.colors?.length) {
        this.labels = [...new Set(this.labels)];
        this.loading = false;
        this.createChart();
      }
    }
  }

  createChart() {
    if (this.chart) this.chart.destroy();

    if (document.getElementById(this.chartId) == null) {
      setTimeout(() => {
        this.createChart();
      }, 100);
      return;
    }

    if (this.data.length == 0) this.isEmpty = true;

    let delayed = true;
    this.chart = new Chart(this.chartId, {
      type: this.type,
      data: {
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            backgroundColor: this.colors,
            borderWidth: 0,
          },
        ],
      },
      options: {
        animation: {
          onComplete: () => {
            delayed = true;
          },
          delay: (context) => {
            let delay = 0;
            if (
              context.type === 'data' &&
              context.mode === 'default' &&
              !delayed
            )
              delay = context.dataIndex * 300 + context.datasetIndex * 100;
            return delay;
          },
        },
        responsive: true,
        aspectRatio: 1,
        plugins: {
          legend: {
            position: this.legendPosition,
            labels: {
              color: this.fontColor,
            },
          },
          title: {
            display: this.title ? true : false,
            text: this.title,
            color: this.fontColor,
            position: 'top',
          },
        },
      },
    });
  }
}
